import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleRight } from "@fortawesome/free-solid-svg-icons";
import { Accordion } from "react-bootstrap/Accordion";
import * as React from 'react';
export default {
  FontAwesomeIcon,
  faChevronCircleRight,
  Accordion,
  React
};